(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("QuadTap", [], factory);
	else if(typeof exports === 'object')
		exports["QuadTap"] = factory();
	else
		root["QuadTap"] = factory();
})(this, () => {
return 